// Localized pricing for the registration wizard.
//
// Each country is billed on its own currency grid. The amounts here mirror the
// values seeded in saas-service (seed_subscription_plans.py) so that what the
// wizard shows matches what the backend actually charges.
//
// Annual = monthly × 10 (≈ 2 months free, -17%), same rule for every currency.

// country -> { key: currency column suffix, symbol }
const COUNTRY_CURRENCY = {
  TN: { key: 'dt', symbol: 'DT' },
  FR: { key: 'eur', symbol: '€' },
  QA: { key: 'qar', symbol: 'QAR' },
  MA: { key: 'mad', symbol: 'MAD' },
  SA: { key: 'sar', symbol: 'SAR' },
};

// Monthly base amounts per plan and currency key.
const MONTHLY_BASE = {
  STARTER: { dt: 99, eur: 30, qar: 149, mad: 330, sar: 149 },
  PROFESSIONAL: { dt: 249, eur: 75, qar: 399, mad: 830, sar: 399 },
  ENTERPRISE: { dt: 999, eur: 300, qar: 1499, mad: 3300, sar: 1499 },
};

const resolveCountry = (countryCode) =>
  COUNTRY_CURRENCY[(countryCode || 'TN').toUpperCase()] || COUNTRY_CURRENCY.TN;

export const currencySymbolFor = (countryCode) => resolveCountry(countryCode).symbol;

// Resolve the price to display for a plan card (Step 3) and payment recap (Step 4).
export function getPlanPricing(planCode, countryCode) {
  const { key, symbol } = resolveCountry(countryCode);
  const base = MONTHLY_BASE[planCode] || MONTHLY_BASE.STARTER;
  const monthly = base[key] ?? base.dt;
  return {
    monthly,
    annual: monthly * 10,
    annualSavings: monthly * 12 - monthly * 10,
    symbol,
  };
}
